/**
 * Shared ScrollTrigger scroll container helpers for TorqWars sections.
 * Desktop scrolls `.page-wrapper`; mobile scrolls `document.scrollingElement`.
 */
(function () {
  'use strict';

  var DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');

  /**
   * @returns {HTMLElement | null}
   */
  function getScroller() {
    var smooth = window.TorqWarsSmoothScroll;
    if (smooth && typeof smooth.getContainer === 'function') {
      var container = smooth.getContainer();
      if (container instanceof HTMLElement) return container;
    }

    if (DESKTOP_QUERY.matches) {
      var pageWrapper = document.querySelector('.page-wrapper');
      if (pageWrapper instanceof HTMLElement) return pageWrapper;
    }

    var scrollingEl = document.scrollingElement || document.documentElement;
    return scrollingEl instanceof HTMLElement ? scrollingEl : null;
  }

  function getScrollTop() {
    var smooth = window.TorqWarsSmoothScroll;
    if (smooth && typeof smooth.getScrollTop === 'function') {
      return smooth.getScrollTop();
    }

    var scroller = getScroller();
    if (scroller) return scroller.scrollTop;
    return window.pageYOffset || 0;
  }

  function setupScrollerProxy() {
    if (window.TorqWarsSmoothScroll && window.TorqWarsSmoothScroll.ensureScrollerProxy) {
      window.TorqWarsSmoothScroll.ensureScrollerProxy();
      return;
    }

    var ScrollTrigger = window.ScrollTrigger;
    if (window.__torqwarsScrollerProxy || !ScrollTrigger) return;

    var scrollRoot = getScroller();
    if (!(scrollRoot instanceof HTMLElement)) return;

    var scrollingEl = document.scrollingElement || document.documentElement;
    if (!DESKTOP_QUERY.matches || scrollRoot === scrollingEl || scrollRoot === document.body) {
      window.__torqwarsScrollerProxy = true;
      return;
    }

    ScrollTrigger.scrollerProxy(scrollRoot, {
      scrollTop: function (value) {
        if (arguments.length) scrollRoot.scrollTop = value;
        return scrollRoot.scrollTop;
      },
      getBoundingClientRect: function () {
        return {
          top: 0,
          left: 0,
          width: scrollRoot.clientWidth,
          height: scrollRoot.clientHeight,
        };
      },
    });

    scrollRoot.addEventListener('scroll', ScrollTrigger.update);
    window.__torqwarsScrollerProxy = true;
  }

  function scheduleScrollRefresh() {
    var smooth = window.TorqWarsSmoothScroll;
    if (smooth && typeof smooth.scheduleRefresh === 'function') {
      smooth.scheduleRefresh();
      return;
    }
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  }

  function resyncSmoothScroll() {
    var smooth = window.TorqWarsSmoothScroll;
    if (smooth && typeof smooth.resync === 'function') {
      smooth.resync();
    }
  }

  /**
   * @param {boolean} active
   */
  function setScrubScrollMode(active) {
    var smooth = window.TorqWarsSmoothScroll;
    if (!smooth || typeof smooth.setScrubMode !== 'function') return;

    if (typeof smooth.isActive === 'function' && !smooth.isActive()) {
      if (!active) smooth.setScrubMode(false);
      return;
    }

    smooth.setScrubMode(active);
  }

  function scrollToPosition(top, immediate) {
    top = Math.max(0, top);
    var smooth = window.TorqWarsSmoothScroll;
    if (smooth && typeof smooth.scrollTo === 'function') {
      smooth.scrollTo(top, { immediate: immediate !== false });
      return;
    }
    var scroller = getScroller();
    if (scroller) scroller.scrollTop = top;
    else window.scrollTo(0, top);
  }

  /**
   * @param {HTMLElement | null | undefined} anchorEl
   * @returns {(() => void) | null}
   */
  function captureVisualPosition(anchorEl) {
    if (!(anchorEl instanceof HTMLElement)) return null;
    var topBefore = anchorEl.getBoundingClientRect().top;
    return function restoreVisualPosition() {
      var topAfter = anchorEl.getBoundingClientRect().top;
      var drift = topAfter - topBefore;
      if (Math.abs(drift) < 1) return;
      scrollToPosition(getScrollTop() + drift, true);
    };
  }

  function getLayoutHandoffAnchor() {
    var manifestoBody = document.querySelector('[data-tw-manifesto] .tw-manifesto__body');
    if (manifestoBody instanceof HTMLElement) return manifestoBody;

    var manifestoInner = document.querySelector('[data-tw-manifesto] .tw-manifesto__inner');
    if (manifestoInner instanceof HTMLElement) return manifestoInner;

    var featuresGrid = document.querySelector('[data-feature-cards] .tw-features__grid');
    if (featuresGrid instanceof HTMLElement) return featuresGrid;

    return null;
  }

  /**
   * @param {() => void} callback
   */
  function afterLayoutSettled(callback) {
    setupScrollerProxy();
    scheduleScrollRefresh();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        resyncSmoothScroll();
        scheduleScrollRefresh();
        callback();
      });
    });
  }

  window.TorqWarsScrollTrigger = {
    getScroller: getScroller,
    getScrollTop: getScrollTop,
    scrollToPosition: scrollToPosition,
    setupScrollerProxy: setupScrollerProxy,
    scheduleScrollRefresh: scheduleScrollRefresh,
    resyncSmoothScroll: resyncSmoothScroll,
    setScrubScrollMode: setScrubScrollMode,
    afterLayoutSettled: afterLayoutSettled,
    captureVisualPosition: captureVisualPosition,
    getLayoutHandoffAnchor: getLayoutHandoffAnchor,
    DESKTOP_QUERY: DESKTOP_QUERY,
  };
})();
